import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils/cn";
const desktopVariants = cva("mx-auto flex flex-col items-center shrink-0 [--base:301px] [--max-width:calc(var(--base)*1)] [--screen-height:calc(var(--base)*0.465116)] [--frame-height:calc(var(--base)*0.571429)] [--bottom-bar-height:calc(var(--base)*0.079734)] [--stand-width:calc(var(--base)*0.25)] [--stand-height:calc(var(--base)*0.175)]", {
  variants: {
    size: {
      sm: "",
      md: "lg:[--base:512px]",
      lg: "lg:[--base:800px]"
    }
  },
  defaultVariants: {
    size: "md"
  }
});
export interface DesktopMockupProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof desktopVariants> {
  children?: React.ReactNode;
}

/**
 * A reusable Desktop/iMac Mockup component for displaying images, videos, or other content.
 * Follows the iMac-style desktop mockup design with dynamic content slot.
 */
export const DesktopMockup: React.FC<DesktopMockupProps> = t0 => {
  const $ = _c(16);
  let children;
  let className;
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      children,
      size,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = size;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    size = $[4];
  }
  let t1;
  if ($[5] !== className || $[6] !== size) {
    t1 = cn(desktopVariants({
      size
    }), className);
    $[5] = className;
    $[6] = size;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== children) {
    t2 = <div className="relative w-full max-w-(--max-width)  border-gray bg-gray border-12 rounded-t-3xl shadow-xl"><div className="overflow-hidden bg-white dark:bg-gray h-(--screen-height) rounded-xl"><div className="relative h-full w-full aspect-video">{children}</div></div></div>;
    $[8] = children;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative w-full bg-[#d6d6d6] border-x-16 border-[#d6d6d6] h-(--bottom-bar-height) rounded-b-3xl" />;
    t4 = <div className="relative bg-gray rounded-b-2xl h-(--stand-height) w-(--stand-width)" />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t3 = $[10];
    t4 = $[11];
  }
  let t5;
  if ($[12] !== props || $[13] !== t1 || $[14] !== t2) {
    t5 = <div className={t1} {...props}>{t2}{t3}{t4}</div>;
    $[12] = props;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};